export const parseLocationSearch = search => {
  return Object.assign({}, ...search.replace('?', '').split(',').map(param => {
    const item = param.split('=');
    return { [item[0]]: item[1] };
  }));
}



// WEBPACK FOOTER //
// ./src/helpers/index.js